import { MetaData } from "./metadata"
import { State } from "./state"


export const Shadow = {
  state : State,
  metadata : MetaData
}
